import { createPortal } from 'react-dom';

function ReactPortal({ children }) {
  return createPortal(children, document.body);
}
export default ReactPortal;